import React, { useContext, useState, useEffect } from "react";
import { stringConstants } from "../../constants";
import { UserContext } from "../../UserContext";

import { GetCMSDocument } from "../../APIManager";

import { ConfigContext } from "../../ConfigContext";

import { Skeleton, Divider, Typography } from "antd";

const { Title } = Typography;

export default function Instructions() {
  const [user, SetUser] = useContext(UserContext);
  const [config] = useContext(ConfigContext);

  const [loading, SetLoading] = useState(true);

  const [instructions, SetInstructions] = useState({
    InternationalInstructions: "",
    LocalInstructions: "",
  });

  function ReplaceVariables(template) {
    return template.replace(
      /{stringConstants\.([\w]+)}/g, // Regex to match {stringConstants.PropertyName}
      (_, key) => config.cpConfig[key] || `{stringConstants.${key}}` // Replace with value or keep the placeholder if not found
    );
  }

  useEffect(() => {
    GetCMSDocument("ClientInstructionsPageInstructions").then((res) => {
      SetInstructions(res?.data?.Data);
      SetLoading(false);
    });
  }, []);

  return (
    <>
      <Divider>
        {" "}
        <Title level={3}>Instructions</Title>
      </Divider>
      <Skeleton loading={loading} paragraph={{ rows: 10 }} />
      <div
        style={{ margin: "auto" }}
        dangerouslySetInnerHTML={{
          __html: ` ${ReplaceVariables(
            user.international
              ? instructions.InternationalInstructionsInstructions
              : instructions.LocalInstructions
          )}`,
        }}
      />
    </>
  );

  if (user.international) {
    return (
      <>
        <div
          dangerouslySetInnerHTML={{
            __html: ` ${ReplaceVariables(
              instructions.InternationalInstructionsInstructions
            )}`,
          }}
        />
      </>
    );
  }

  return (
    <div
      dangerouslySetInnerHTML={{
        __html: ` ${ReplaceVariables(instructions.LocalInstructions)}`,
      }}
    />
  );
}
